import store from '@/store/store';
import moment from 'moment';
import { getAll } from '@/api/logistique/ordreTravailAffichage/index';
import genererCritereRecherche from '@/services/logistique/ordreTravail/affichage/genererCritereRechercheOrdreTravailAffichage';
import * as types from './ordreTravailAffichage-mutation-type';
import * as allTypes from '../../mutation-type';

function initialState() {
  return {
    items: [],
    total: 0,
    critereRecherche: genererCritereRecherche(),
    ordreTravailAffichageCourant: null,
    lastPayload: {},
    faceARemplacer: null,
    otAnnonceur: null,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL](state, total) {
    state.total = total;
  },
  [types.SET_CRITERES](state, critereRecherche) {
    state.critereRecherche = critereRecherche;
  },
  [types.SET_OT_COURANT](state, otCourant) {
    state.ordreTravailAffichageCourant = otCourant;
  },
  [types.SET_OT_ANNONCEUR](state, otAnnonceur) {
    state.otAnnonceur = otAnnonceur;
  },
  [types.SET_LAST_PAYLOAD](state, payload) {
    state.lastPayload = payload;
  },
  [types.SET_FACE_A_REMPLACER](state, face) {
    state.faceARemplacer = face;
  },
  [allTypes.RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadOrdreTravail({ commit }, param) {
    const response = await getAll(param);
    response.data.result.items.forEach((ordreTravail) => {
      ordreTravail.selected = false;
    });
    commit(types.SET_LAST_PAYLOAD, param);
    commit(types.SET_TOTAL, response.data.result.totalCount);
    commit(types.SET_ITEMS, response.data.result.items);
    return {};
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  total: state => {
    return state.total;
  },
  critereRecherche: state => {
    const dateDebut = store.getters['demande/dateSelect'];
    state.critereRecherche.periode[0] = dateDebut;
    if (dateDebut > state.critereRecherche.periode[1]) {
      state.critereRecherche.periode[1] = moment(dateDebut).endOf('week').toDate();
    }
    return state.critereRecherche;
  },
  ordreTravailAffichageCourant: state => {
    return state.ordreTravailAffichageCourant;
  },
  otAnnonceur: state => {
    return state.otAnnonceur;
  },
  lastPayload: state => {
    return state.lastPayload;
  },
  faceARemplacer: state => {
    return state.faceARemplacer;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
